import {
    AmericanExpressGreySVGIcon, DinersGreySVGIcon, DiscoverGreySVGIcon, JCBGreySVGIcon,
    MastercardGreySVGIcon, UnionpayGreySVGIcon,
    VisaGreySVGIcon
} from '../../../../ui/svg/shopping-cart/credit-cards/large-grey-credit-cards.svg';
import {
    AlipayIcon,
    AmericanExpressBlueSVGIcon, DinersBlueSVGIcon, DiscoverBlueSVGIcon, JCBBlueSVGIcon,
    MastercardBlueSVGIcon, PaypalIcon, UnionpayBlueSVGIcon,
    VisaBlueSVGIcon
} from '../../../../ui/svg/shopping-cart/credit-cards/large-blue-credit-cards.svg';
import { PaymentMethodEnum } from '../../../../domain/cart/payment-method-enum';
import React from 'react';

export const UPDATE_SAVED_CREDIT_CARDS_EVENT = 'UPDATE_SAVED_CARDS_EVT';

export const getPaymentMethod = (brand: string) => {
    const vendor = brand?.trim().toLowerCase() || '';

    // VISA, visa/dankort, LeumiVisa
    if (vendor.includes("visa")) return PaymentMethodEnum.Visa;

    // MasterCard, LeumiMasterCard
    if (vendor.includes("mastercard")) return PaymentMethodEnum.MasterCard;

    // american express, AmericanExpress
    if (vendor.includes("americanexpress") || vendor.includes("american express")) return PaymentMethodEnum.AmericanExpress;

    // Discover, elo/discover
    if (vendor.includes("discover") ||
        vendor.includes("elo")) return PaymentMethodEnum.Discover;

    // PayPal
    if (vendor.includes("paypal")) return PaymentMethodEnum.PayPal;

    // Diners, diners club international
    if (vendor.includes("diners")) return PaymentMethodEnum.Diners;

    // JCB
    if (vendor.includes("jcb")) return PaymentMethodEnum.JCB;

    // AliPay
    if (vendor.includes("alipay")) return PaymentMethodEnum.AliPay;

    // china union pay, UnionPay
    if (vendor.includes("unionpay") || vendor.includes("union pay")) return PaymentMethodEnum.UnionPay;

    return PaymentMethodEnum.Undefined;
}
export const getSavedCreditCardsIcon = (paymentMethod: PaymentMethodEnum, isSelected: boolean) => {

    switch (paymentMethod){
        case PaymentMethodEnum.Visa: {
            return isSelected ? <VisaBlueSVGIcon /> : <VisaGreySVGIcon/>;
        }
        case PaymentMethodEnum.MasterCard: {
            return isSelected ? <MastercardBlueSVGIcon/> : <MastercardGreySVGIcon/>;
        }
        case PaymentMethodEnum.AmericanExpress: {
            return isSelected ? <AmericanExpressBlueSVGIcon/> : <AmericanExpressGreySVGIcon/>;
        }
        case PaymentMethodEnum.Discover: {
            return isSelected ? <DiscoverBlueSVGIcon/> : <DiscoverGreySVGIcon/>;
        }
        case PaymentMethodEnum.PayPal: {
            return isSelected ? <PaypalIcon /> : <PaypalIcon color1="#A7A9AC" color2="#808285" />;
        }
        case PaymentMethodEnum.Diners: {
            return isSelected ? <DinersBlueSVGIcon /> : <DinersGreySVGIcon/>;
        }
        case PaymentMethodEnum.JCB: {
            return isSelected ? <JCBBlueSVGIcon/> : <JCBGreySVGIcon/>;
        }
        case PaymentMethodEnum.AliPay: {
            return <AlipayIcon />;
        }
        case PaymentMethodEnum.UnionPay: { // 10
            return isSelected ? <UnionpayBlueSVGIcon/> : <UnionpayGreySVGIcon/>;
        }

        /*
        case 'maestro': {
            return isSelected ? <MaestroBlueSVGIcon/> : <MaestroGreySVGIcon/>;
        }*/
    }

    return '';
};

/**
 * get saved credit card SVG icon by vendor name

export const getSavedCreditCardsIcon = (vendorName: string, isSelected: boolean) => {
    const vendor = vendorName.toLowerCase();

    switch (vendor){
        case 'visa': {
            return isSelected ? <VisaBlueSVGIcon /> : <VisaGreySVGIcon/>;
        }
        case 'mastercard': {
            return isSelected ? <MastercardBlueSVGIcon/> : <MastercardGreySVGIcon/>;
        }
        case 'maestro': {
            return isSelected ? <MaestroBlueSVGIcon/> : <MaestroGreySVGIcon/>;
        }
        case 'american express': {
            return isSelected ? <AmericanExpressBlueSVGIcon/> : <AmericanExpressGreySVGIcon/>;
        }
        case 'discover': {
            return isSelected ? <DiscoverBlueSVGIcon/> : <DiscoverGreySVGIcon/>;
        }
        case 'jcb': {
            return isSelected ? <JCBBlueSVGIcon/> : <JCBGreySVGIcon/>;
        }
    }

    if(vendor.indexOf('union pay') !== -1){
        return isSelected ? <UnionpayBlueSVGIcon/> : <UnionpayGreySVGIcon/>;
    }

    if(vendor.startsWith('diners')){
        return isSelected ? <DinersBlueSVGIcon/> : <DinersGreySVGIcon/>;
    }

    return '';
}; */
